<script>
export let x;
export let y1;
export let y2 = -10;
export let value;
</script>

<g class="line-marker" role="graphics-object">
    <line x1={x}
          x2={x}
          y1={y1}
          y2={y2}
          role="graphics-symbol" />
    <g class="line-anno-label line-anno-label-halo" transform="translate({x + 5}, 0)">
      <text class="line-anno-label-value">
        {value}
      </text>
    </g>
    <g class="line-anno-label" transform="translate({x + 5}, 0)">
      <text class="line-anno-label-value">
        {value}
      </text>
    </g>
</g>
